import { useCallback, useContext, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import cookie from 'js-cookie';
import { motion, useReducedMotion } from 'motion/react';
import { SessionContext } from 'auth/SessionProvider';
import ErrorPage from 'components/ErrorPages/ErrorPage';
import './NoAdminAccessPage.less';

const SIGN_OUT_AFTER_MS = 2000;
const EASE = [0.22, 1, 0.36, 1] as const;

function NoAdminAccessPage() {
  const intl = useIntl();
  const { logout } = useContext(SessionContext);
  const reduceMotion = useReducedMotion();
  const signedOut = useRef(false);

  const signOut = useCallback(() => {
    if (signedOut.current) return;
    signedOut.current = true;
    cookie.remove('CloudAdminSSO');
    cookie.remove('CloudAdminSSO', { domain: process.env.REACT_APP_DOMAIN });
    logout({ returnTo: window.location.origin });
  }, [logout]);

  useEffect(() => {
    const timer = setTimeout(signOut, SIGN_OUT_AFTER_MS);
    return () => clearTimeout(timer);
  }, [signOut]);

  const progress = reduceMotion ? null : (
    <motion.span
      className="NoAdminAccessPage__track"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.16, ease: EASE }}
    >
      <motion.span
        className="NoAdminAccessPage__fill"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: SIGN_OUT_AFTER_MS / 1000, ease: 'linear' }}
      />
    </motion.span>
  );

  return (
    <ErrorPage
      headerContent={
        <>
          {intl.formatMessage({ id: 'auth0.errorPages.noAdminAccess.header' })}
        </>
      }
      subheaderContent={
        <span className="NoAdminAccessPage__countdown" role="status">
          {intl.formatMessage({
            id: 'auth0.errorPages.noAdminAccess.signingOut',
          })}
          {progress}
        </span>
      }
      onReturnToLoginPage={signOut}
    />
  );
}

export default NoAdminAccessPage;
